module.exports = __webpack_public_path__ + "img/pic_4@2x.029a1070.png";